<template>
  <div class="index">
    <v-overlay color="#FFB5CC" opacity="1"></v-overlay>
    <img
      class="indexBackground"
      src="@/assets/images/index/background.jpg"
      style="object-fit: cover"
      alt=""
    />
    <div class="indexTitle">
      <div>
        <h1 class="logoIcon"><img src="@/assets/logo_white.svg" alt="we done"></h1>
        <p class="logoLine"></p>
        <p class="logoTitle">We Done!</p>
        <div class="indexLogin">
          <div
            v-if="agent.indexOf('ios') > -1"
            @click="
              dialog = true;
              type = 'apple';
            "
          >
            <div
              style="max-width: 300px;"
              id="appleid-signin"
              data-mode="center-align"
              data-type="sign-in"
              data-color="black"
              data-border="false"
              data-border-radius="15"
              data-height="45"
            ></div>
          </div>
          <!-- <div
            @click="
              dialog = true;
              type = 'kakao';
            "
          >
            <img
              src="@/assets/images/index/login_kakao.png"
              alt="카카오 로그인"
            />
          </div> -->
        </div>

        <!-- <overlay-loader :overlay="ad" /> -->
        <!-- <v-btn @click="ad = true">광고보기 테스트</v-btn> -->
        <v-btn @click="helperLogin" style="margin-right: 8px;">서포터 로그인</v-btn>
        <v-btn @click="challengerLogin">챌린저 로그인</v-btn>
        <!-- <Admob :ad="ad" @closed="ad = false" @succeed="succeed = true" /> -->
        <!-- <privacy-policy :dialog="dialog" @agree="agree" /> -->
      </div>
    </div>
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
// 맨 처음 화면 (최초 설치, 로그인 이전)
import PrivacyPolicy from "../../components/app/PrivacyPolicy.vue";
// import Admob from "@/components/Admob";
import OverlayLoader from "@/components/OverlayLoader";
export default {
  // components: { PrivacyPolicy, OverlayLoader },
  name: "Index",
  data() {
    return {
      type: undefined,
      dialog: false,
      // ad: false,
      // succeed: undefined,
      alert: false,
      alertMessage: undefined,
    };
  },
  watch: {
    ad(v) {
      if (v === true) {
        this.succeed = undefined;
      }
    },
  },
  computed: {
    agent() {
      return navigator.userAgent.toLowerCase();
    },
  },
  methods: {
    agree() {
      if (this.type === "kakao") {
        this.$router.push("/social/" + this.type);
      } else if (this.type === "apple") {
        try {
          window.AppleID.auth.signIn();
        } catch (e) {
          this.alert = true;
          this.alertMessage = "Apple ID로 로그인 할 수 없습니다. 설정을 확인하세요.";
          return false;
        }
      }
    },
    async helperLogin() {
      // var pushToken = window.localStorage.getItem("pushToken");
      // if (!pushToken) {
      //   window.localStorage.setItem("pushToken", "helpertoken");
      // }
      // await window.localStorage.setItem(
        //   "userInfo",
      //   '{"username":"kakao1663344874","token":"Token 3641c745bf6ca98497075244c7062795ed67ea8c","nickname":"도전만든사람"}'
      // );
      // await window.localStorage.setItem(
        //   "challengeInfo",
      //   '{"id":16,"code":"pqwql7br0hok5vzvxlh9","type":"helper","partner":true}'
      // );
      window.localStorage.setItem("pushToken", "helpertoken");
      this.$router.push("/division");
    },
    async challengerLogin() {
      // var pushToken = window.localStorage.getItem("pushToken");
      // if (!pushToken) {
      //   window.localStorage.setItem("pushToken", "challengertoken");
      // }
      // await window.localStorage.setItem(
        //   "userInfo",
      //   '{"username":"kakao1665911821","token":"Token f5e0bcb7fb7641f8e23c4581ca99eab0ba6dbc35","nickname":"도전하는사람"}'
      // );
      // await window.localStorage.setItem(
        //   "challengeInfo",
      //   '{"id":16,"code":"pqwql7br0hok5vzvxlh9","type":"challenger","partner":true}'
      // );
      window.localStorage.setItem("pushToken", "challengertoken");
      this.$router.push("/division");
    },
  },
  mounted() {
    window.AppleID.auth.init({
      clientId: "wedone.storybro.co.kr",
      scope: "name email",
      redirectURI: process.env.VUE_APP_SERVICE_URL,
      usePopup: true,
    });
    //Listen for authorization success
    document.addEventListener("AppleIDSignInOnSuccess", (data) => {
      this.$axios
        .post("/users/tokens/apple", {
          id_token: data.detail.authorization.id_token,
          user: data.detail.user,
        })
        .then((response) => {
          if (response.data.success) {
            this.$router.push(
              "/social/apple?token=" +
                response.data.id_token +
                "&name=" +
                response.data.name +
                "&email=" +
                response.data.email
            );
          }
        });
      //handle successful response
    });
    //Listen for authorization failures
    document.addEventListener("AppleIDSignInOnFailure", (error) => {
      console.log(error);
      //handle error.
    });
  },
};
</script>
<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .indexBackground {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
  }
  .indexTitle {
    position: relative;
    z-index: 10;
  }
  .indexLogin {
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: wrap;
    position: fixed;
    left: 0;
    bottom: 20px;

    >div{
      margin: 4px;
    }
    img {
      max-width: 100%;
      vertical-align: -3px;
    }
  }
}
.alert{
  bottom: 164px;
  color: #fff;
  background-color: rgba(0,0,0,.4);
}
</style>